import { put, call, takeLatest } from 'redux-saga/effects'

import { getCurrencies as getCurrenciesApi } from 'Service/Api'

import * as CurrencyTypes from 'Redux/Types/CurrencyTypes'
import * as CurrencyActions from 'Redux/Actions/CurrencyActions'

function* getCurrencies() {
  try {
    const { data } = yield call(getCurrenciesApi)
    yield put(CurrencyActions.getCurrenciesSucceeded(data))
  } catch (errors) {
    yield put(CurrencyActions.getCurrenciesFailed(errors))
  }
}

export default function* CurrencySaga() {
  yield takeLatest(CurrencyTypes.GET_CURRENCIES, getCurrencies)
}
